/**
 * Shared styles for Button and IconButton components
 */

export const variantClasses = {
  primary:
    'bg-uiv2-btn-primary text-white hover:bg-uiv2-btn-primary-hover disabled:bg-uiv2-btn-disabled-bg disabled:text-uiv2-btn-disabled-text',
  secondary:
    'bg-uiv2-btn-secondary text-uiv2-btn-secondary-text hover:bg-uiv2-btn-secondary-hover shadow-[inset_0_0_0_1px_#D5D7DA] disabled:bg-uiv2-btn-disabled-bg disabled:text-uiv2-btn-disabled-text disabled:shadow-[inset_0_0_0_1px_#E9EAEB]',
  outline:
    'bg-white text-uiv2-gray-light-700 hover:bg-uiv2-gray-light-50 shadow-[inset_0_0_0_1px_#D5D7DA] disabled:bg-uiv2-gray-light-50 disabled:text-uiv2-btn-disabled-text disabled:shadow-[inset_0_0_0_1px_#E9EAEB]',
  ghost:
    'bg-transparent text-uiv2-gray-light-700 hover:bg-uiv2-gray-light-50 disabled:text-uiv2-btn-disabled-text disabled:hover:bg-transparent',
  destructive:
    'bg-uiv2-error-700 text-white hover:bg-uiv2-error-800 disabled:bg-uiv2-btn-disabled-bg disabled:text-uiv2-btn-disabled-text',
  'destructive-secondary':
    'bg-white text-uiv2-error-800 hover:bg-uiv2-error-100 hover:text-uiv2-error-900 shadow-[inset_0_0_0_1px_#FDA29B] focus-visible:ring-uiv2-error-600 disabled:bg-uiv2-btn-disabled-bg disabled:text-uiv2-btn-disabled-text disabled:shadow-[inset_0_0_0_1px_#E9EAEB]',
} as const;

export type ButtonVariant = keyof typeof variantClasses;

export const baseClasses =
  'font-sans font-semibold focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-uiv2-btn-primary transition-colors inline-flex items-center justify-center rounded-pb-2 disabled:cursor-not-allowed disabled:pointer-events-none';
